<template>
    <div>
        <van-nav-bar
        title="关注店铺"
        />
        <van-loading vertical v-if="loading"/>
        <van-radio-group v-model="follow">
            <van-cell-group>
                <van-cell v-for="item in shoplist" :key="item.id" :title="item.name" clickable @click="followShop(item.shop_id)">
                    <template #icon>      
                        <van-radio :name="item.id" />
                    </template>
                    <template #right-icon>   
                        <van-icon name="clear" color="red" size="17" @click.stop="unfollow(item)"/>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-radio-group>
 
        <van-action-sheet v-model="show" :actions="actions" cancel-text="取消"  :description="description" @select="onSelect()" />

    </div>
</template>

<script>
import { Cell, CellGroup, NavBar, Loading, Divider, RadioGroup, Radio, Button, Icon, PullRefresh, Toast, ActionSheet } from 'vant';
import { UserShopInfoApi } from '@/api/shop'
import { toErrorPage } from '@/utils/usePage'

export default {
    components: {
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [NavBar.name]: NavBar,
        [Loading.name]: Loading,
        [Divider.name]: Divider,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [Button.name]: Button,
        [Icon.name]: Icon,
        [PullRefresh.name]: PullRefresh,
        [Toast.name]: Toast,
        [ActionSheet.name]: ActionSheet
    },
    data() {
        return {
            shoplist: [],
            follow: 1,
            loading: true,
            show: false,
            actions: [
                { name: '取消关注' }
            ],
            description:'',
            unfollowShop: 0
        }
    },
    mounted(){
        this.getShopInfo()
    },
    methods: {
        getDescription(shopName){
            this.description = '取消关注“'+ shopName +'”后将不再收到其下发的消息'
        },
        getShopInfo() {
            var that = this
            that.axios.get(UserShopInfoApi,{params: {type:'follow'} }).then((ret) => {
                this.loading = false
                if (ret.flag) {
                    ret = ret.details
                    this.shoplist = ret
                    ret.forEach(item => {
                        if(item.follow){
                            this.follow = item.id
                            this.getDescription(item.name)
                            return
                        }
                    })
                } else {
                    toErrorPage(this,'',ret.info,null)
                    // Toast.error(ret.info)
                }
            })
        },
        followShop(shop_id){
            var that = this
            Toast.loading({
                message: '加载中...',
                forbidClick: true
            });
            that.axios.post(UserShopInfoApi, {
                shop: shop_id
            }).then((ret) => {
                console.log(ret)
                this.getShopInfo()
                Toast.clear()
                Toast.success('切换店铺成功');
            })
        },
        unfollow(val){
            console.log(val, val.shop_id)
            this.show = true
            this.unfollowShop = val.shop_id
            this.getDescription(val.name)
        },
        onSelect(){
            this.show = false
            var that = this
            that.axios.delete(UserShopInfoApi + this.unfollowShop + '/')
            .then((ret) => {
                console.log(ret)
                this.getShopInfo()
            })
            .catch(function (error) {
                console.log(error)
            })
        }
    }
}
</script>

<style lang="less" scoped>

</style>